import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Video, emptyVideo } from "../../interfaces/Video";
import { useNavigate } from "react-router-dom";
import VideoEdit from "./VideoEdit";
import VideoDelete from "./VideoDelete";
import VideoAdd from "./VideoAdd";
import { MainLayout } from "../../layout/MainLayout";
import { useTranslation } from "react-i18next";
import { handleApiError, safeJsonParse } from "../../../utils/api";

export default function Videos() {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const isAdmin = localStorage.getItem('isAdmin');
    
    const [videos, setVideos] = useState<Video[]>([]);
    const [selectedVideo, setSelectedVideo] = useState<Video>(emptyVideo);
    const [showAddForm, setShowAddForm] = useState(false);
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);

    useEffect(() => {
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/video-tutorials', requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                setVideos(data);
            });
    }, []);

    const handleShowAddForm = () => {
        setShowAddForm(true);
    }

    const handleHideAddForm = () => {
        setShowAddForm(false);
    }

    const handleSumbitAddForm = (f: Video) => {
        const newVideos = videos.map((video: Video) => { return video; })
        newVideos.push(f);
        setVideos(newVideos);
        setShowAddForm(false);
    }
    
    const handleShowDeleteForm = (event: any, id: string) => {
        event.preventDefault()
        const newSelectedVideo: Video = videos.find((f: Video) => f._id == id) ?? emptyVideo;
        if (newSelectedVideo._id != '') {
            setSelectedVideo(newSelectedVideo);
            setShowDeleteForm(true);
        } else {
            alert(t("No Video selected."));
        }
    }
    
    const handleHideDeleteForm = () => {
        setShowDeleteForm(false);
    }

    const handleSumbitDeleteForm = (id: string) => {
        const newVideos = videos.filter((f: Video) => f._id != id);
        setVideos(newVideos);
        setShowDeleteForm(false);
    }
    
    const handleShowEditForm = (event: any, id: string) => {
        event.preventDefault()
        const newSelectedVideo: Video = videos.find((f: Video) => f._id == id) ?? emptyVideo;
        if (newSelectedVideo._id != '') {
            setSelectedVideo(newSelectedVideo);
            setShowEditForm(true);
        } else {
            alert(t("No Video selected."));
        }
    }
    
    const handleHideEditForm = () => {
        setShowEditForm(false);
    }

    const handleSumbitEditForm = (video: Video) => {
        const newVideos = videos.map((f: Video) => {
            if (f._id == video._id) {
                return video;
            } else {
                return f;
            }
        });
        setVideos(newVideos);
        setShowEditForm(false);
    }

    return (
        <MainLayout>
            <div className="container-fluid">
                <div className="row">
                    { isAdmin &&
                        <div className="admin-videos-container">
                                    <div className="page-header">
                                        <h1>{ t("Video management") }</h1>
                                        <div className="page-actions">
                                            <a className="action-icon" onClick={ handleShowAddForm } title={ t("New Video") }>
                                                <i className="bi bi-plus-circle"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="admin-videos-table-container">
                                        <div className="inner">
                                            { videos.map((f: Video) => {
                                                return(
                                                    <div className="video-item" key={ 'video-' + f._id }>
                                                        { f.media.length > 0 &&
                                                            <div className="video media-item">
                                                                <video controls key={ f._id + '-' + (f.updated || Date.now()) }>
                                                                    <source src={ import.meta.env.VITE_API_URL + '/' + f.media[0].path + '?t=' + (f.updated || Date.now()) } />
                                                                </video>
                                                            </div>
                                                        }
                                                        <div className="title">
                                                            { f.title }
                                                        </div>
                                                        <div className="meta">
                                                            <div className="code">
                                                                { '[video="' + f._id + '"]' }
                                                            </div>
                                                            <div className="actions">
                                                                <a className="edit" title={ t("Edit Video") }
                                                                    href="#" onClick={ (event) => handleShowEditForm(event, f._id) }></a>
                                                                <a className="delete" title={ t("Delete Video") }
                                                                    href="#" onClick={ (event) => handleShowDeleteForm(event, f._id) }></a>
                                                            </div>
                                                        </div>                                                    
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            }
                    { !isAdmin &&
                        <div className="admin-videos-container">
                            { t("You are not allowed to access this section.") }
                        </div>
                    }
                </div>
            </div>
            { showAddForm &&
                <VideoAdd submitCallback={ handleSumbitAddForm } closeCallback={ handleHideAddForm } />
            }
            { showDeleteForm &&
                <VideoDelete video={ selectedVideo } submitCallback={ handleSumbitDeleteForm } closeCallback={ handleHideDeleteForm } />
            }
            { showEditForm &&
                <VideoEdit video={ selectedVideo } submitCallback={ handleSumbitEditForm } closeCallback={ handleHideEditForm } />
            }
        </MainLayout>);
}